import { useEffect, useState } from "react";

const left = (ts, now) => {
  const s = Math.round((new Date(ts) - now) / 1000);
  const a = Math.abs(s);
  const txt = `${Math.floor(a / 3600)}h ${String(Math.floor((a % 3600) / 60)).padStart(2, "0")}m ${String(a % 60).padStart(2, "0")}s`;
  return s >= 0 ? `in ${txt}` : `${txt} ago`;
};

export const NextEvent = ({ ev }) => {
  const [now, setNow] = useState(new Date());
  useEffect(() => {
    const id = setInterval(() => setNow(new Date()), 1000);
    return () => clearInterval(id);
  }, []);
  return (
    <section className={`desk-card half-lg ${ev?.in_blackout ? "!border-[color:var(--red)]" : ""}`} data-testid="desk-next-event">
      <h2>Next big USD event</h2>
      {!ev ? <p className="text-lg text-[color:var(--mute)]" data-testid="desk-next-none">No more high-impact USD events this week.</p> : (
        <div className="flex flex-wrap items-end justify-between gap-3">
          <div className="min-w-0">
            <div className="text-2xl font-bold leading-tight" data-testid="desk-next-title">{ev.title}</div>
            <div className="desk-mono text-base text-[color:var(--mute)] mt-1" data-testid="desk-next-time">{ev.gst} GST · {ev.ist} IST</div>
          </div>
          <div className="desk-mono text-3xl sm:text-4xl font-semibold text-[color:var(--gold)]" data-testid="desk-next-countdown">{left(ev.ts, now)}</div>
          <div className={`w-full text-base font-semibold ${ev.in_blackout ? "text-[color:var(--red)]" : "text-[color:var(--mute)]"}`} data-testid="desk-next-blackout">
            {ev.in_blackout ? "BLACKOUT ACTIVE: no new trades" : "No trades 30 min before to 30 min after"}
          </div>
        </div>
      )}
    </section>
  );
};
